"use strict";

var _regeneratorRuntime = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelFileUpload = exports.addQueueFiles = exports.uploadFile = exports.deleteFileOrFolder = exports.createFolder = exports.fetchFolder = void 0;

var axios_1 = require("axios");

var moment = require("moment");

var _1 = require(".");

var api_1 = require("../../api");

var notification_1 = require("../notification");

var actions_1 = require("./actions");

var model_1 = require("./model");

var CancelToken = axios_1.default.CancelToken;
var fileUploadCancelers = [];

var fetchFolder = function fetchFolder(brandIdOrSlug, path) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var drive;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context.prev = 1;
              _context.next = 4;
              return (0, api_1.apiRequest)('GET', "/brands/".concat(brandIdOrSlug, "/drive").concat(path ? "/".concat(path) : '/'));

            case 4:
              drive = _context.sent;
              dispatch((0, actions_1.setDrive)(drive));
              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              dispatch((0, actions_1.setLoading)(false));
              dispatch((0, notification_1.setNotification)(notification_1.NotificationType.ERROR, notification_1.NotificationMessages.FETCH_VALUE_ERROR, _1.DRIVE_NOTIFICATION_KEY));

            case 13:
              dispatch((0, actions_1.setLoading)(false));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
  };
};

exports.fetchFolder = fetchFolder;

var createFolder = function createFolder(brandIdOrSlug, name, path) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context2.prev = 1;
              _context2.next = 4;
              return (0, api_1.apiRequest)('POST', "/brands/".concat(brandIdOrSlug, "/drive").concat(path ? "/".concat(path) : '', "/").concat(name));

            case 4:
              dispatch((0, actions_1.addFolder)(path ? "".concat(path, "/").concat(name) : name));
              dispatch((0, notification_1.setNotification)(notification_1.NotificationType.SUCCESS, notification_1.NotificationMessages.CREATE_SUCCESS, _1.DRIVE_NOTIFICATION_KEY));
              _context2.next = 13;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);
              dispatch((0, actions_1.setLoading)(false));
              dispatch((0, notification_1.setNotification)(notification_1.NotificationType.ERROR, notification_1.NotificationMessages.CREATE_ERROR, _1.DRIVE_NOTIFICATION_KEY));

            case 13:
              dispatch((0, actions_1.setLoading)(false));

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }));
  };
};

exports.createFolder = createFolder;

var deleteFileOrFolder = function deleteFileOrFolder(brandIdOrSlug, path) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context3.prev = 1;
              _context3.next = 4;
              return (0, api_1.apiRequest)('DELETE', "/brands/".concat(brandIdOrSlug, "/drive/").concat(path));

            case 4:
              dispatch((0, actions_1.removeFileOrFolder)(path));
              dispatch((0, notification_1.setNotification)(notification_1.NotificationType.SUCCESS, notification_1.NotificationMessages.DELETE_SUCCESS, _1.DRIVE_NOTIFICATION_KEY));
              _context3.next = 13;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              console.error(_context3.t0);
              dispatch((0, actions_1.setLoading)(false));
              dispatch((0, notification_1.setNotification)(notification_1.NotificationType.ERROR, notification_1.NotificationMessages.DELETE_ERROR, _1.DRIVE_NOTIFICATION_KEY));

            case 13:
              dispatch((0, actions_1.setLoading)(false));

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8]]);
    }));
  };
};

exports.deleteFileOrFolder = deleteFileOrFolder;

var uploadFile = function uploadFile(brandIdOrSlug, file, path) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var payload, filePath, startTime, fileResponse;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch((0, actions_1.setLoading)(true));
              _context4.prev = 1;
              payload = new FormData();
              payload.append('file', file);
              filePath = path ? "".concat(path, "/").concat(file.name) : file.name;
              startTime = moment.now();
              dispatch((0, actions_1.updateQueueFileStatus)(filePath, model_1.UploadStatus.Uploading));
              _context4.next = 9;
              return axios_1.default.request({
                baseURL: api_1.axiosInstance.defaults.baseURL,
                headers: {
                  authorization: api_1.axiosInstance.defaults.headers.common['Authorization']
                },
                method: 'POST',
                url: "/brands/".concat(brandIdOrSlug, "/drive").concat(path ? "/".concat(path) : '/'),
                data: payload,
                onUploadProgress: function onUploadProgress(progressEvent) {
                  var percent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                  var elpasedTime = moment().diff(startTime, 'seconds');
                  var speed = progressEvent.loaded / elpasedTime;
                  dispatch((0, actions_1.setBytesUploaded)(progressEvent.loaded));
                  dispatch((0, actions_1.setUploadSpeed)(speed));

                  if (percent > 0) {
                    dispatch((0, actions_1.updateFileProgress)(filePath, Math.round(progressEvent.loaded * 100 / progressEvent.total)));
                  }
                },
                cancelToken: new CancelToken(function (c) {
                  fileUploadCancelers.push(c);
                })
              });

            case 9:
              fileResponse = _context4.sent;
              dispatch((0, actions_1.setBytesUploaded)(0));
              dispatch((0, actions_1.removeWaitingFile)(path ? "".concat(path, "/").concat(file.name) : file.name));
              dispatch((0, actions_1.addFile)(Object.assign(Object.assign({}, fileResponse.data), {
                status: model_1.UploadStatus.Done,
                progress: undefined,
                displayName: file.name
              })));
              dispatch((0, notification_1.setNotification)(notification_1.NotificationType.SUCCESS, notification_1.NotificationMessages.FETCH_VALUES_SUCCESS, _1.DRIVE_NOTIFICATION_KEY));
              _context4.next = 23;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](1);
              console.error(_context4.t0);
              dispatch((0, actions_1.setLoading)(false));
              dispatch((0, actions_1.setBytesUploaded)(0));
              dispatch((0, actions_1.removeWaitingFile)(path ? "".concat(path, "/").concat(file.name) : file.name));

              if (_context4.t0.status === 409) {
                dispatch((0, notification_1.setNotification)(notification_1.NotificationType.ERROR, notification_1.NotificationMessages.FETCH_VALUES_ERROR, _1.DRIVE_NOTIFICATION_KEY));
              }

            case 23:
              dispatch((0, actions_1.setLoading)(false));

            case 24:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 16]]);
    }));
  };
};

exports.uploadFile = uploadFile;

var addQueueFiles = function addQueueFiles(files, path, brandSlug) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var queueFiles, filteredFiles;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queueFiles = getState().driveState.queuedFiles;
              filteredFiles = files.filter(function (f) {
                return !queueFiles.map(function (q) {
                  return q.displayName;
                }).includes(f.name);
              });
              filteredFiles.forEach(function (file) {
                return dispatch((0, actions_1.addQueueFile)({
                  displayName: file.name,
                  name: path ? "".concat(path, "/").concat(file.name) : file.name,
                  contentType: file.type,
                  url: null,
                  status: model_1.UploadStatus.Waiting,
                  progress: 0,
                  size: file.size,
                  brandSlug: brandSlug,
                  file: file,
                  path: path
                }));
              });

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  };
};

exports.addQueueFiles = addQueueFiles;

var cancelFileUpload = function cancelFileUpload() {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch((0, actions_1.emptyQueue)());
              fileUploadCancelers.map(function (cancel) {
                return cancel();
              });

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  };
};

exports.cancelFileUpload = cancelFileUpload;